<template>
  <div class="jin-pc-details jin-pc jin-pc-height">
    <div class="jin-pc-container jin-details-con">
      <Breadcrumb />
      <Common />
    </div>
  </div>
</template>

<script>
import Common from './common'
export default {
  components: {
    Common
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.jin {
  &-pc {
    &-details {
      background: #f4f5f9;
    }
  }

  /deep/ &-details {
    &-warp {
      padding: 0 40px;
    }

    &-body {
      padding: 40px 0 0;

      .date {
        font-size: 14px;
        line-height: 20px;
      }

      &-item {
        margin-top: 36px;
        padding-bottom: 4px;

        p {
          font-size: 18px;
          line-height: 30px;
          margin-bottom: 7px;
        }

        ul {
          li {
            p {
              font-size: 14px;
              line-height: 40px;
            }
          }
        }
      }
    }

    &-footer {
      padding: 40px 0;

      .share,
      .submit {
        width: 150px;
        height: 48px;
        border-radius: 24px;
        font-size: 14px;
        font-weight: 500;
      }

      .share {
        margin-right: 30px;
        position: relative;

        &-con {
          width: 240px;
          box-sizing: border-box;
          background: #fff;
          box-shadow: 4px 4px 8px 0 rgba(0, 0, 0, 0.2);
          position: absolute;
          left: 50%;
          bottom: calc(100% + 10px);
          transform: translateX(-50%);
          padding: 20px 20px 40px;
          display: none;

          &-active {
            display: block;
          }

          &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: -12px;
            transform: translateX(-50%);
            border: 6px solid #fff;
            border-color: #fff transparent transparent transparent;
          }

          p {
            font-size: 14px;
            color: #3d4351;
            line-height: 20px;
          }

          .qrcode-warp {
            margin-bottom: 24px;

            .qrcode {
              margin-top: 15px;
              display: flex;
              justify-content: center;
            }
          }

          .link-warp {
            .link {
              margin-top: 5px;
              display: flex;
              align-items: center;
              height: 32px;
              border-radius: 2px;
              border: 1px solid #f4f5f9;

              .el-input {
                flex: 1;
                height: 100%;

                input {
                  height: 100%;
                  border: none;
                  padding: 0 0 0 7px;
                }
              }

              span {
                cursor: pointer;
                display: block;
                width: 80px;
                height: 100%;
                background: #3d4351;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 30px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
